import { render, staticRenderFns } from "./faceFrame.vue?vue&type=template&id=d34392a8&scoped=true"
import script from "./faceFrame.vue?vue&type=script&lang=js"
export * from "./faceFrame.vue?vue&type=script&lang=js"
import style0 from "./faceFrame.vue?vue&type=style&index=0&id=d34392a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34392a8",
  null
  
)

export default component.exports